import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Footer } from '../components/shared/Footer';

const BLACKBOARD_BG = "https://customer-assets.emergentagent.com/job_cef8a789-684e-42da-8da6-08c3769b942a/artifacts/02czd85l_blackboard%20texture%200102.jpg";

export const Privacy = () => {
  const navigate = useNavigate();

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div 
      className="min-h-screen"
      style={{
        fontFamily: "'Manrope', system-ui, sans-serif",
        backgroundImage: `linear-gradient(rgba(255,255,255,0.08), rgba(255,255,255,0.08)), url(${BLACKBOARD_BG})`,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="text-white hover:bg-white/10 hover:text-[#D4AF37] mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Retour
        </Button>

        <div className="bg-white/30 backdrop-blur-sm rounded-lg p-8 border border-white/30 shadow-xl">
          <h1 
            className="text-3xl font-extrabold text-white mb-6"
          >
            Politique de confidentialité
          </h1>
          
          <p className="text-white/70 mb-6">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>

          <div className="space-y-6 text-white/90">
            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">1. Responsable du traitement</h2>
              <p>
                AuMenu.ch<br />
                Email : <a href="mailto:info@aumenu.ch" className="text-[#D4AF37] hover:underline">info@aumenu.ch</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">2. Cadre juridique</h2>
              <p>
                La présente politique de confidentialité est établie conformément à la Loi fédérale suisse 
                sur la protection des données (LPD) et, le cas échéant, au Règlement général sur la 
                protection des données (RGPD) de l'Union européenne.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">3. Données collectées</h2>
              <p className="mb-2">
                Notre site web collecte uniquement les données suivantes :
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong className="text-white">Données de localisation</strong> (optionnel) : Si vous l'autorisez, nous utilisons 
                votre position géographique pour calculer la distance aux restaurants. Cette donnée 
                n'est pas stockée sur nos serveurs.</li>
                <li><strong className="text-white">Favoris</strong> : Vos restaurants favoris sont stockés localement dans votre 
                navigateur (localStorage) et ne sont pas transmis à nos serveurs.</li>
                <li><strong className="text-white">Données techniques</strong> : Adresse IP, type de navigateur, pages visitées 
                (à des fins de statistiques et de sécurité).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">4. Finalités du traitement</h2>
              <p>Les données sont utilisées pour :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Afficher les plats du jour des restaurants</li>
                <li>Calculer la distance entre votre position et les restaurants (si autorisé)</li>
                <li>Améliorer notre service et assurer la sécurité du site</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">5. Partage des données</h2>
              <p>
                Nous ne vendons, ne louons et ne partageons pas vos données personnelles avec des tiers, 
                sauf obligation légale.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">6. Cookies</h2>
              <p>
                Notre site utilise uniquement des cookies techniques nécessaires au fonctionnement du site. 
                Aucun cookie de tracking ou publicitaire n'est utilisé.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">7. Durée de conservation</h2>
              <p>
                Les données techniques (logs) sont conservées pendant une durée maximale de 12 mois. 
                Les favoris stockés localement persistent jusqu'à ce que vous les supprimiez ou 
                effaciez les données de votre navigateur.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">8. Vos droits</h2>
              <p className="mb-2">
                Conformément à la LPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong className="text-white">Droit d'accès</strong> : obtenir des informations sur vos données traitées</li>
                <li><strong className="text-white">Droit de rectification</strong> : corriger des données inexactes</li>
                <li><strong className="text-white">Droit à l'effacement</strong> : demander la suppression de vos données</li>
                <li><strong className="text-white">Droit à la portabilité</strong> : recevoir vos données dans un format structuré</li>
                <li><strong className="text-white">Droit d'opposition</strong> : vous opposer au traitement de vos données</li>
              </ul>
              <p className="mt-2">
                Pour exercer ces droits, contactez-nous à : <a href="mailto:info@aumenu.ch" className="text-[#D4AF37] hover:underline">info@aumenu.ch</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">9. Sécurité</h2>
              <p>
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour 
                protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">10. Modifications</h2>
              <p>
                Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
                Les modifications seront publiées sur cette page avec une date de mise à jour.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-3">11. Contact</h2>
              <p>
                Pour toute question concernant cette politique de confidentialité ou le traitement de 
                vos données, contactez-nous à : <a href="mailto:info@aumenu.ch" className="text-[#D4AF37] hover:underline">info@aumenu.ch</a>
              </p>
            </section>

            <section className="pt-4 border-t border-white/20">
              <p className="text-sm text-white/50">
                En cas de litige, le droit suisse est applicable et les tribunaux du canton de Genève sont compétents.
              </p>
            </section>
          </div>
        </div>

        <Footer className="mt-8" showTitle={false} showPrivacyLink={false} />
      </div>
    </div>
  );
};
